/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_Componente_dk_100_107 as Componente_dk_100_107,
  rec_Componente_nk_110_107 as Componente_nk_110_107,
  rec_EstadoError as EstadoError,
  rec_EstructuraPrincipal as EstructuraPrincipal,
  rec_Fo as Fo,
  rec_FormularioUnidad as FormularioUnidad,
  rec_JSXRuntime as JSXRuntime,
  rec_KO as KO,
  rec_React as React,
  rec_TarjetaUnidad as TarjetaUnidad,
  rec_Ti as Ti,
  rec_VO as VO,
  rec_api as api,
  rec_esAdministrador as esAdministrador,
  rec_qO as qO,
  rec_qx as qx,
  rec_yi as yi,
  rec_zo as zo,
} from "../../runtime/index.jsx";
export function ArbolOrganizacion() {
  let e = esAdministrador(),
    { confirmar: t } = Fo(),
    [n, r] = (0, React.useState)(null),
    [i, a] = (0, React.useState)(!0),
    [o, s] = (0, React.useState)(``),
    [c, l] = (0, React.useState)(null),
    u = (0, React.useCallback)(async () => {
      (a(!0), s(``));
      try {
        r(await api(`/mis-areas`));
      } catch (e) {
        s(e.message);
      } finally {
        a(!1);
      }
    }, []);
  (0, React.useEffect)(() => {
    u();
  }, [u]);
  let {
    raices: f,
    hijosDe: p,
    proyectosDe: m,
  } = (0, React.useMemo)(() => qO(n), [n]);
  async function h(e) {
    if (
      await t({
        titulo: `Eliminar "${e.nombre}"`,
        mensaje: `Se borra la unidad del organigrama. No se puede deshacer.`,
        confirmarTexto: `Eliminar`,
        peligro: !0,
      })
    )
      try {
        (await api(`/unidades/${e.id}`, {
          method: `DELETE`,
        }),
          u());
      } catch (e) {
        s(e.message);
      }
  }
  let g = m.get(VO) ?? [],
    _ = f.length === 0 && g.length === 0;
  return (
    <EstructuraPrincipal
      title={`Organización`}
      children={[
        <div
          className={`flex flex-col gap-5`}
          children={[
            <div
              className={`flex flex-wrap items-center justify-between gap-2`}
              children={[
                <p
                  className={`text-sm text-(--text)`}
                  children={
                    n?.esAdmin
                      ? `Todas las áreas de la empresa y sus proyectos.`
                      : `Las áreas donde trabajás y sus proyectos.`
                  }
                />,
                e && (
                  <button
                    type={`button`}
                    onClick={() =>
                      l({
                        padreId: null,
                        tipo: `CORPORATIVA`,
                      })
                    }
                    className={zo}
                    children={[
                      <Ti className={`mr-1 inline h-3.5 w-3.5`} />,
                      ` `,
                      qx(`CORPORATIVA`),
                    ]}
                  />
                ),
              ]}
            />,
            <EstadoError mensaje={o} onReintentar={u} />,
            i ? (
              <Componente_dk_100_107 />
            ) : _ ? (
              <div
                className={`animar-entrada rounded-2xl border border-dashed border-(--border) p-10 text-center`}
                children={[
                  (0, JSXRuntime.jsx)(yi, {
                    className: `mx-auto h-8 w-8 text-(--text)`,
                  }),
                  <p
                    className={`mt-2 text-sm text-(--text)`}
                    children={
                      e
                        ? `Todavía no hay nada armado. Empezá por la gerencia más alta y de ahí colgá el resto.`
                        : `Todavía no tenés áreas. Pedile a quien administra el sistema que te sume a la tuya.`
                    }
                  />,
                ]}
              />
            ) : (
              <div
                className={`flex flex-col gap-5`}
                children={[
                  f.length > 0 && (
                    <div
                      className={`animar-cascada grid gap-3 sm:grid-cols-2 lg:grid-cols-3`}
                      children={f.map((t) => (
                        <TarjetaUnidad
                          key={t.id}
                          unidad={t}
                          totales={KO(t, p, m)}
                          esAdmin={e}
                          onEditar={async () => {
                            // La tarjeta trae un resumen sin las personas: para editar se
                            // carga la unidad completa, como en su detalle (2026-10-08).
                            let completa = t;
                            try {
                              completa = { ...t, ...(await api(`/unidades/${t.id}`)) };
                            } catch {}
                            l({
                              editar: completa,
                            });
                          }}
                          onEliminar={() => h(t)}
                        />
                      ))}
                    />
                  ),
                  g.length > 0 && (
                    <section
                      className={`rounded-2xl border border-(--border) bg-(--bg) p-4`}
                      children={[
                        <p
                          className={`mb-2 text-sm font-medium text-(--text-h)`}
                          children={`Otros proyectos donde participás`}
                        />,
                        <Componente_nk_110_107 proyectos={g} />,
                      ]}
                    />
                  ),
                ]}
              />
            ),
          ]}
        />,
        c && (
          <FormularioUnidad
            datos={c}
            onClose={() => l(null)}
            onGuardado={() => {
              (l(null), u());
            }}
          />
        ),
      ]}
    />
  );
}
